import classnames from 'classnames';
import React, { useState } from 'react';

import { SkeletonRect } from '@ekhodealer/ekho-common/rev';

import './BlemishThumbnail.scss';

interface BlemishThumbnailProps {
	/** Public GCS URL for the blemish image */
	publicUrl: string;
	/** Alt text for the rendered image */
	alt: string;
}

export const BlemishThumbnail = ({ publicUrl, alt }: BlemishThumbnailProps): React.JSX.Element | null => {
	const [isLoaded, setIsLoaded] = useState(false);

	if (!publicUrl) {
		return null;
	}

	return (
		<div className='blemish-thumbnail'>
			{!isLoaded && <SkeletonRect width='100%' height='100%' />}
			<img
				src={publicUrl}
				alt={alt}
				className={classnames('blemish-thumbnail__image', {
					'blemish-thumbnail__image--hidden': !isLoaded,
				})}
				onLoad={() => setIsLoaded(true)}
				onError={() => setIsLoaded(true)}
			/>
		</div>
	);
};
